export function redactPersonalData(text: string): string {
    if (!text) return text;

    const urlRegExp = /(https?:\/\/)?(www\.)?[a-zA-Z0-9@:%._+~#=-]+\.[a-zA-Z0-9()@:%_+.~#?&/=-]*/g;
    const emailRegExp = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;
    const phoneRegExp = /(\(?\+?\d{1,3}\)?)*([\s-.()]*[\d]{2,})+/g;
    const socialMediaRegExp = /@[^\s]{3,}/g;

    return text
        .replace(urlRegExp, '...')
        .replace(emailRegExp, '...')
        .replace(phoneRegExp, '...')
        .replace(socialMediaRegExp, '...');
}
